export default "__VITE_ASSET__a385385e__"